import { Observable } from "rxjs";
import { IScriptOriginTag } from "./interfaces/IScriptOriginTag";

export abstract class IScriptOriginStream {
  abstract getLibraryOrigin$(): Observable<IScriptOriginTag>;
  abstract push(url: string | null);
}
